import { categoryConstants } from "@/_constants";

const initialState = {
  categories: [],
  isLoading: false,
  error: null,
};

export const category = (state = initialState, action) => {
  switch (action.type) {
    case categoryConstants.GET_CATEGORIES_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case categoryConstants.GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        categories: action.payload,
        error: null,
      };

    case categoryConstants.GET_CATEGORIES_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
